import LaunchIcon from "@mui/icons-material/Launch";
import { IconButton } from "@mui/material";
import { Link } from "react-router-dom";

/**
 * Component for rendering a link cell in the tasks table
 * @param {Object} props - Component props
 * @param {Object} props.params - Cell parameters containing row data
 * @returns {JSX.Element} Link cell with icon button
 */
const LinkCell = ({ params }) => (
  <IconButton size="small">
    <Link to={params.row["log_stream_url"].replace("https://internallinkhumans.link", "")}>
      <LaunchIcon fontSize="small" />
    </Link>
  </IconButton>
);
export default LinkCell;
